import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import LoadingPage from '../../molecules/LoadingPage'

export default (Comp) => {
    
    class ProtectedRoute extends Component {
        state = {
            loading: true,
            granted: false
        }
        
        componentDidMount() {
            this.verifyUserIsLogged(this.props.user)
        }

        componentWillReceiveProps(nextProps) {
            this.verifyUserIsLogged(nextProps.user)
        }

        verifyUserIsLogged({ status, userData }) {
            if(status === 'done') {
                this.setState({
                    loading: false,
                    granted: userData ? true :  false
                })
            }
        }
        
        render() {
            
            if(this.state.loading)
            return <LoadingPage />
            
            if(!this.state.granted) {
                window.location.href = `/login?redirect_to=${window.location.pathname}`
            }
            
            
            return <Comp {...this.props} />
        }
        
    }

    const mapDispatchToProps = {

    }

    const mapStateToProps = store => ({
        user: store.user
    })

    return connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute)
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/organisms/ProtectedRoute/index.js